export default {
  notification: {
    message: 'Plus que <span>%{amount}</span> pour gagner un paquet de plus du jeu des 7 familles',
    action: 'Le jeu',
  },
  modal: {
    title: '+100.000€ de cadeaux à gagner',
    description: '1 paquet de 4 cartes offert tous les 50€ d’achats en ligne ou en magasin.',
  },
};
